var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{staticStyle:{"margin-top":"5px"},attrs:{"size":"small","type":_vm.params.typeStyle},on:{"click":_vm.onBtn}},[_vm._v(_vm._s(_vm.params.label))])}
var staticRenderFns = []

export { render, staticRenderFns }